import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import "./Navbar.css";

const Navbar = () => {
  const { isAuthenticated, logout, user } = useAuth();

  const handleLogout = () => {
    logout();
  };

  const isAdmin = () => {
    return user && user.role >= 2;
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link
          to="/"
          className="nav-logo">
          <img
            src="/big.png"
            alt="LineaBlu Logo"
          />
        </Link>

        {isAuthenticated() && (
          <div className="nav-links">
            <Link
              to="/dashboard"
              className="nav-link logout-button">
              Dashboard
            </Link>
            {isAdmin() && (
              <Link
                to="/admin"
                className="nav-link logout-button">
                Admin Console
              </Link>
            )}
            <button
              onClick={handleLogout}
              className="logout-button">
              Logout
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
